module.exports = __webpack_public_path__ + "img/home-img-people-1.58117cba.jpg";